import './sample_detail.style.scss';
import '../probands_samples/probands_samples.style.scss';

import { Col, Result, Row, Spin } from 'antd';
import React from 'react';
import { useParams } from 'react-router-dom';

import { useGetSampleDetailQuery } from '../api/variantApi';
import DetailCard from '../variant_workflow/components/DetailCard';
import SampleDetailClinicalReportsSection from './SampleDetailClinicalReportsSection';
import SampleDetailMainSection from './SampleDetailMainSection';
import SampleDetailSideSection from './SampleDetailSideSection';

const SampleDetailPage = () => {
  const { sampleId } = useParams<{ sampleId: string }>();
  const {
    data: sample,
    isError,
    isLoading,
    refetch: refetchSampleDetail,
  } = useGetSampleDetailQuery({ sample_id: sampleId }, { skip: !sampleId });

  if (isLoading) {
    return (
      <div className="sample-detail sample-detail__state">
        <Spin />
      </div>
    );
  }

  if (isError || !sample) {
    return (
      <div className="sample-detail sample-detail__state">
        <Result
          status="error"
          title="Unable to load sample"
          subTitle={`Sample ${sampleId ?? ''} could not be loaded.`}
        />
      </div>
    );
  }

  return (
    <div className="sample-detail">
      <div className="sample-detail__link">
        <span>Sample: {sample?.sample_id ?? sampleId}</span>
      </div>
      <Row gutter={[8, 8]} className="sample-detail__content">
        <Col flex="auto" className="sample-detail__main">
          <DetailCard>
            <SampleDetailMainSection sample={sample} />
          </DetailCard>
          <DetailCard>
            <SampleDetailClinicalReportsSection
              sample={sample}
              onReportGenerated={refetchSampleDetail}
            />
          </DetailCard>
        </Col>
        <Col flex="30%" className="sample-detail__side">
          <DetailCard>
            <SampleDetailSideSection sample={sample} />
          </DetailCard>
        </Col>
      </Row>
    </div>
  );
};

export default SampleDetailPage;
